import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useState } from 'react';
import { DatePicker as BaseDatePicker, } from 'react-aria-components';
import { parseDate, CalendarDate, today, getLocalTimeZone } from '@internationalized/date';
import { useController } from 'react-hook-form';
import { FormErrorMessage } from '../form/error-message';
import { DefaultContent } from './default-content';
import { DatePickerButton } from './button';
import { DefaultTrigger } from './default-trigger';
dayjs.extend(utc);
export { DefaultContent };
export function DatePicker({ min, max, value, onChange, name, title, trigger, content, }) {
    const [isOpen, setOpen] = useState(false);
    const minValue = min ? parseDate(min.format('YYYY-MM-DD')) : undefined;
    const maxValue = max ? parseDate(max.format('YYYY-MM-DD')) : undefined;
    const selectedDate = value
        ? parseDate((typeof value === 'string' ? dayjs.utc(value) : value).format('YYYY-MM-DD'))
        : null;
    const [visibleDate, setVisibleDate] = useState(selectedDate
        ? new CalendarDate(selectedDate.year, selectedDate.month, selectedDate.day)
        : today(getLocalTimeZone()));
    const handleDateChange = (date) => {
        onChange?.(date ? dayjs.utc(date.toString()) : undefined);
        if (date && typeof date.year === 'number' && typeof date.month === 'number' && typeof date.day === 'number') {
            setVisibleDate(new CalendarDate(date.year, date.month, date.day));
        }
    };
    const handleMonthChange = (month) => setVisibleDate(new CalendarDate(visibleDate.year, month, 1));
    const handleYearChange = (year) => setVisibleDate(new CalendarDate(year, visibleDate.month, 1));
    const handlePreviousMonth = () => setVisibleDate(visibleDate.subtract({ months: 1 }));
    const handleNextMonth = () => setVisibleDate(visibleDate.add({ months: 1 }));
    const contentProps = {
        selectedDate,
        visibleDate,
        minValue,
        maxValue,
        onDateChange: handleDateChange,
        onMonthChange: handleMonthChange,
        onYearChange: handleYearChange,
        onPreviousMonth: handlePreviousMonth,
        onNextMonth: handleNextMonth,
        title,
        isOpen,
        onClose: () => setOpen(false),
    };
    return (_jsxs(BaseDatePicker, { name: name, value: selectedDate, onChange: handleDateChange, minValue: minValue, maxValue: maxValue, isOpen: isOpen, onOpenChange: setOpen, "aria-labelledby": "date input", children: [trigger
                ? trigger()
                : _jsx(DefaultTrigger, {}), content
                ? content(contentProps)
                : _jsx(DefaultContent, { ...contentProps })] }));
}
export function FormDatePicker({ name, ...props }) {
    const { field, fieldState } = useController({ name });
    return (_jsxs("div", { className: "flex flex-col w-full gap-stack-tight", children: [_jsx(DatePicker, { ...props, value: field.value, onChange: (date) => field.onChange(date?.toISOString()) }), _jsx(FormErrorMessage, { error: fieldState.error?.message })] }));
}
DatePicker.Button = DatePickerButton;
